import { app } from '@microsoft/teams-js';
import { useEffect, useState } from 'react';
import { getMSTeamsTheme } from '../ms-teams-sdk/util/MsTeamsContextUtil';
import { Logger } from '../packages/logger/src/Logger';
import registerOnThemeChangeHandler = app.registerOnThemeChangeHandler;

type WebexThemes = 'darkWebex' | 'lightWebex';

const teamsToWebexTheme: { [key: string]: WebexThemes } = {
  default: 'lightWebex',
  dark: 'darkWebex',
  contrast: 'darkWebex',
};

export const useMsTeamsTheme = () => {
  const [theme, setTheme] = useState<WebexThemes>('lightWebex');

  const setWebexTheme = (teamsTheme: string) => {
    Logger.debug(`Registered Ms Teams theme change to: ${teamsTheme}`);
    const webexTheme = teamsToWebexTheme[teamsTheme] || 'lightWebex';
    setTheme(webexTheme);
  };

  useEffect(() => {
    getMSTeamsTheme().then((teamsTheme) => {
      setWebexTheme(teamsTheme);
    });
    registerOnThemeChangeHandler((newTheme) => setWebexTheme(newTheme));
  }, []);

  return [theme];
};
